var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-iconstack',{attrs:{"font-scale":"1"}},[_c('b-icon',{attrs:{"stacked":"","icon":"cart-fill"}}),_vm._v(" "),_c('b-icon',{staticStyle:{"stroke":"var(--main-color)","stroke-width":"1px"},attrs:{"stacked":"","icon":"plus","shift-h":"10","shift-v":"7"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }